import { Link, useLocation, useNavigate } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react"; // You may use other icons or SVGs
import FooterLogo from "../../assets/Footer/Footer/footer-logo.svg";

const FooterLink = ({ children, to = "#", onClick }) => (
  <Link
    to={to}
    onClick={onClick}
    className="text-[12px] sm:text-[13px] md:text-[14px] text-white hover:text-gray-300 font-inter"
  >
    {children}
  </Link>
);

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleScrollLink = (sectionId) => {
    if (location.pathname !== "/") {
      navigate("/", { replace: false });
      setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    } else {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <footer className="bg-[var(--footer-theme)] text-white px-6 py-8 sm:px-10 lg:px-24 ">
      {/* Top Section */}
      <div className="grid grid-cols-1 lg:grid-cols-4 mb-6">
        {/* Logo and Description */}
        <div className="lg:col-span-2 mb-5">
          <img 
            src={FooterLogo} 
            alt="Logo" 
            className="mb-4 w-[180px]"
            loading="lazy"
            decoding="async"
            fetchpriority="low"
          />
          <p className="text-sm leading-relaxed text-gray-300">
            At Roselea Care Home, we believe everyone deserves to feel safe,
            respected, and truly at home. Our care is built around each person
            understanding their story, their needs, and their dreams. With
            compassion at the heart of what we do, we support every individual
            to live with dignity, confidence, and as much independence as
            possible, all within a warm and welcoming environment.
          </p>
        </div>

        {/* Company */}
        <div className="lg:ml-20">
          <h4 className="font-semibold mb-4 text-white text-[16px]">Company</h4>
          <ul className="space-y-2">
            <li>
              <FooterLink
                to="/about"
                onClick={() => handleScrollLink("aboutus")}
              >
                About Us
              </FooterLink>
            </li>
            <li>
              <FooterLink
                to="/contact-us"
                onClick={() => handleScrollLink("contactus")}
              >
                Contact Us
              </FooterLink>
            </li>
            <li>
              <FooterLink
                to="/services"
                onClick={() => handleScrollLink("services")}
              >
                Services
              </FooterLink>
            </li>
            <li>
              <FooterLink
                to="/life-at-roselea"
                onClick={() => handleScrollLink("services")}
              >
                Life At Roselea
              </FooterLink>
            </li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="font-semibold mb-4 mt-5 lg:mt-0 text-white text-[16px]">
            Reach Us
          </h4>
          <ul className="space-y-3 text-gray-300 text-sm">
            <li className="flex items-start gap-2">
              <MapPin className="w-4 h-4 mt-1" />
              <a
                // href="https://www.google.com/maps?q=No+01+ABC+Road,+Cherry+Hill,+United+Kingdom"
                href="https://maps.app.goo.gl/EvfZLVssQFjSVj8p7"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline"
              >
                73 Loughborough Road, West Bridgford, Nottingham NG2 7JX, UK
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Phone className="w-4 h-4" />
              <a href="tel:+441158462250" className="hover:underline">
                (+44) 115 846 2250
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Mail className="w-4 h-4" />
              <a
                href="mailto:info@roseleacarehomes.com"
                className="hover:underline"
              >
                info@roseleacarehomes.com
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Divider */}
      <div className="border-t border-gray-500 pt-4 flex flex-col md:flex-row items-center justify-between text-sm text-gray-400 font-inter">
        <span>Roselea © {new Date().getFullYear()}. All rights reserved.</span>
        <div className="flex space-x-4 mt-2 md:mt-0">
          <FooterLink>Terms & Conditions</FooterLink>
          <FooterLink>Privacy Policy</FooterLink>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
